<script>import { toCSSVars } from "../utils/toCSSVars";
import { setTheme, useTwistThemeSafe } from "./store";
import { DefaultTwistTheme } from "./theme";
import { createTokensFromScale } from "..";
export let theme = DefaultTwistTheme;
const currentTheme = useTwistThemeSafe();
const themeStore = setTheme(theme);
$:
  themeStore.set(theme);
$:
  currentThemeVars = [
    toCSSVars($currentTheme?.scales?.borderRadius ? createTokensFromScale($currentTheme?.scales?.borderRadius) : {}),
    toCSSVars($currentTheme?.scales?.fontSize ? createTokensFromScale($currentTheme?.scales?.fontSize) : {}),
    toCSSVars($currentTheme?.scales?.letterSpacing ? createTokensFromScale($currentTheme?.scales?.letterSpacing) : {}),
    toCSSVars($currentTheme?.scales?.lineHeight ? createTokensFromScale($currentTheme?.scales?.lineHeight) : {}),
    toCSSVars($currentTheme?.scales?.spacing ? createTokensFromScale($currentTheme?.scales?.spacing) : {}),
    toCSSVars($currentTheme?.tokens?.colors ?? {}),
    toCSSVars($currentTheme?.tokens?.fonts ?? {}),
    toCSSVars($currentTheme?.tokens?.transitionDurations ?? {}),
    toCSSVars($currentTheme?.tokens?.transitionFunctions ?? {})
  ].flat();
$:
  newThemeVars = [
    toCSSVars(createTokensFromScale(theme.scales.borderRadius)),
    toCSSVars(createTokensFromScale(theme.scales.fontSize)),
    toCSSVars(createTokensFromScale(theme.scales.letterSpacing)),
    toCSSVars(createTokensFromScale(theme.scales.lineHeight)),
    toCSSVars(createTokensFromScale(theme.scales.spacing)),
    toCSSVars(theme.tokens.colors),
    toCSSVars(theme.tokens.fonts),
    toCSSVars(theme.tokens.transitionDurations),
    toCSSVars(theme.tokens.transitionFunctions)
  ].flat();
$:
  uniqNewVars = newThemeVars.filter((v) => !currentThemeVars.includes(v));
</script>

<div style={uniqNewVars.join('')}>
  <slot />
</div>

<style>
  div {
    display: contents;
  }
</style>
